import { ServiceDataFields } from './service-data-fields.enum';

export const nipptFieldSet = [
  ServiceDataFields.AdditionalPatientInformation,
  ServiceDataFields.DocumentNumber,
  ServiceDataFields.Ethnicity,
  ServiceDataFields.AllegedFather,
  ServiceDataFields.PregnancyInformation,
  ServiceDataFields.DueDate,
  ServiceDataFields.PregnancyType,
  ServiceDataFields.Ivf,
  ServiceDataFields.PatientHistoryInformation,
  ServiceDataFields.RecentPregnancy,
  ServiceDataFields.ParticipantsStemCellTherapy,
  ServiceDataFields.ParticipantsBloodTransfusion,
];
